import http from '../core/http-common'
import { SharedOffice, SharedOfficeResponse, SharedOfficeRequest } from '../types/SharedOffice'

class SharedOfficeService {
  getCheckFloorIsAvailable(request: SharedOfficeRequest) {
    return http.post<SharedOfficeResponse>('/SharedOffice/CheckFloorAvailable', request)
  }
}
export default new SharedOfficeService()
